export default __webpack_public_path__ + "static/media/logo.90dc3575.png";